import type { BackendApiErrorUnion } from '@vs-shop/engine/data/error/backendApi/_internal/createBackendApiError';
import { makeMiscModule } from '@vs-shop/engine/module/misc/makeMiscModule';
import { AddressShow } from '@vs-shop/schemas/branded/MiscSchema';
import type { BannerPlacementTypeT } from '../../enum/bannerPlacement';
import { makeGetBanners } from '../request/backendApi/banner/makeGetBanners';
import { makeGetHomepage } from '../request/backendApi/homepage/makeGetHomepage';
import { AlertMessageIndex, Banner, HomepageShow, ProductBase } from '../schema/openapi/backend';
import type { AddressCreate, AddressUpdate } from '../schema/openapi/backend';

const addressCreateBody = (data: AddressCreate) => data;
const addressFirstName = (data: AddressCreate) => data.firstName;
const addressUpdateBody = (data: AddressUpdate) => data;
const bannerPlacementQuery = (placement: BannerPlacementTypeT) => ({ placement });

const miscModule = makeMiscModule({
  addressShow: AddressShow,
  alertMessageIndex: AlertMessageIndex,
  productBase: ProductBase,
  addressCreateBody,
  addressFirstName,
  addressTraceFields: (address) => ({
    firstName: address.firstName,
    lastName: address.lastName,
  }),
  addressUpdateBody,
});

// Banners and the homepage are rcprofi-only: RacingLine's backend serves
// neither endpoint, so their request modules live in this package and are bound
// here rather than in the shared engine's misc module.
const bannerModule = makeGetBanners({ banner: Banner, bannerPlacementQuery });
const homepageModule = makeGetHomepage({ homepageShow: HomepageShow });

export const CreateAddressError = miscModule.CreateAddressError;
export const UpdateAddressError = miscModule.UpdateAddressError;
export const GetFavouriteListProductsError = miscModule.GetFavouriteListProductsError;
export const createAddress = miscModule.createAddress;
export const updateAddress = miscModule.updateAddress;
export const listAlertMessages = miscModule.listAlertMessages();
export const listBanners = bannerModule.listBanners;
export const requestFavouriteListProducts = miscModule.requestFavouriteListProducts;
export const getHomepage = homepageModule.getHomepage();

export type CreateAddressError = BackendApiErrorUnion<typeof CreateAddressError>;
export type UpdateAddressError = BackendApiErrorUnion<typeof UpdateAddressError>;
export type AlertMessageListError = BackendApiErrorUnion<typeof miscModule.ListAlertMessagesError>;
export type BannerListError = BackendApiErrorUnion<typeof bannerModule.ListBannersError>;
export type GetFavouriteListProductsError = BackendApiErrorUnion<
  typeof GetFavouriteListProductsError
>;
export type HomepageGetError = BackendApiErrorUnion<typeof homepageModule.GetHomepageError>;
